import React from 'react';

import { useDismissable } from 'app/developer-v3/hooks';

import MigrationDone from './MigrationDone';

type Props = {
  completedZapsCount: number;
  helpLinks: React.ReactNode;
  persistId?: string;
};

function DismissableMigrationDone(props: Props) {
  const { completedZapsCount, helpLinks, persistId } = props;

  const { dismiss, isVisible } = useDismissable({ persistId });

  return (
    isVisible && (
      <MigrationDone
        completedZapsCount={completedZapsCount}
        helpLinks={helpLinks}
        onDismiss={dismiss}
      />
    )
  );
}

export default DismissableMigrationDone;
